import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=be6632b4&scoped=true"
import script from "./top-menu.vue?vue&type=script&lang=ts"
export * from "./top-menu.vue?vue&type=script&lang=ts"
import style0 from "./top-menu.vue?vue&type=style&index=0&id=be6632b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6632b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
